import { styled } from '@linaria/react';

import type { OperatorWithSnippet } from './OperatorLookup.types';

const Match = ({
  label,
  definition,
  example,
  link,
  disclaimer,
}: OperatorWithSnippet) => {
  return (
    <Wrapper>
      <Intro>
        This is the{' '}
        <strong style={{ color: 'var(--color-secondary)' }}>
          {label}
        </strong>{' '}
        operator.
      </Intro>
      <DefinitionWrapper>{definition}</DefinitionWrapper>
      {example && <CodeWrapper>{example}</CodeWrapper>}
      {disclaimer && (
        <DefinitionWrapper>{disclaimer}</DefinitionWrapper>
      )}

      <MDNLink href={link} target="_blank" rel="noopener noreferer">
        Read more about this operator{' '}
        <FakeTextLink>on MDN</FakeTextLink>.
      </MDNLink>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: relative;
  z-index: 3;
  text-align: left;
  margin-top: 64px;
  animation: fadeIn 500ms 500ms both;
`;

const Intro = styled.p`
  font-size: 1.3125rem;
  text-align: center;
`;

const DefinitionWrapper = styled.div`
  margin: 32px 0;
  font-size: 1.125rem;

  p {
    margin-bottom: 24px;
  }
`;

const CodeWrapper = styled.div`
  position: relative;
  margin-top: 48px;
`;

const MDNLink = styled.a`
  display: block;
  color: var(--color-gray-1000);
  margin-top: 48px;
  font-size: 1.125rem;
  text-decoration: none;

  @media (min-width: 610px) {
    text-align: center;
    background: var(--color-muted);
    padding: 16px;
    border-radius: 8px;
  }
`;

const FakeTextLink = styled.span`
  display: inline-block;
  position: relative;
  font-weight: var(--font-weight-medium);

  &:after {
    content: '';
    position: absolute;
    left: -2px;
    right: -2px;
    bottom: 0px;
    height: 2px;
    background-color: var(--color-primary);
    border-radius: 2px;
    transition:
      transform 200ms 150ms,
      opacity 350ms 150ms;
  }
`;

export default Match;
